import React from 'react';
import Icon from '../../../components/AppIcon';

const ResultsStats = ({ meetingPoints, participants }) => {
  const formatDuration = (minutes) => {
    if (minutes < 60) return `${minutes} min`;
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  };

  const allTravelTimes = meetingPoints?.flatMap(mp => mp?.travelTimes?.map(t => t?.duration));
  const avgTravelTime = allTravelTimes?.length > 0 
    ? Math.round(allTravelTimes?.reduce((sum, t) => sum + t, 0) / allTravelTimes?.length)
    : 0;

  const fairLocations = meetingPoints?.filter(mp => {
    const times = mp?.travelTimes?.map(t => t?.duration);
    const max = Math.max(...times);
    const min = Math.min(...times);
    return (max - min) <= 5;
  })?.length;

  const stats = [
    {
      icon: 'MapPin',
      label: 'Meeting Points',
      value: meetingPoints?.length?.toString(),
      color: 'text-primary'
    },
    {
      icon: 'Clock',
      label: 'Avg Travel Time',
      value: formatDuration(avgTravelTime),
      color: 'text-accent'
    },
    {
      icon: 'CheckCircle',
      label: 'Fair Time Options',
      value: fairLocations?.toString(),
      color: 'text-success'
    },
    {
      icon: 'Users',
      label: 'Participants',
      value: participants?.length?.toString(),
      color: 'text-secondary'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {stats?.map((stat, index) => (
        <div 
          key={index}
          className="bg-card border border-border rounded-lg p-4 md:p-5 shadow-md hover-lift transition-smooth"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className={`w-10 h-10 ${stat?.color?.replace('text-', 'bg-')}/10 rounded-lg flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
          </div>
          <p className="data-text text-xl md:text-2xl font-bold text-foreground mb-1">
            {stat?.value}
          </p>
          <p className="caption text-muted-foreground">
            {stat?.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ResultsStats;